import Icon from "@portal/components/atoms/icons";
import Typography from "@portal/components/atoms/v2/typography";
import { MainBox } from "../components/mainBox";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { useAppSelector } from "@portal/redux/store";
import { RobotFooterComponent } from "../components/footer";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import { SustainabilityInfo } from "./steps/sustainability";
import { SFDRInfo } from "./steps/sfdr";
import { PAIInfo } from "./steps/pai";
import { EUInfo } from "./steps/eu";
import { IRiskLevel } from "@portal/types/robot/IRiskLevel";
import Link from "next/link";

export const SustainabilityPage = ({ pageIndex, centerId, isDefaultLanguage }: IPageProps) => {
  const { request } = useAppSelector(state => state.persisted.riskLevel);
  const isButtonEnabled = IsValidRequest(request);
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <>
      <MainBox>
        <Typography variant="Body">{texts.PAGE_7_INFO_HEADER}</Typography>
        <div className="flex h-[210px] justify-center mt-2">
          <Icon name="sustainabilityIcon" size="image" />
        </div>
        <Typography variant="H6">{texts.PAGE_7_SUBHEADER}</Typography>
        <TextLine />
        <SustainabilityInfo isDefaultLanguage={isDefaultLanguage} />
        <SFDRInfo isDefaultLanguage={isDefaultLanguage} />
        <PAIInfo isDefaultLanguage={isDefaultLanguage} />
        <EUInfo isDefaultLanguage={isDefaultLanguage} />
        <div className="flex my-2">
          <Link prefetch={false} href="https://norne.no/baerekraft/" target="_blank" className="flex underline items-start">
            <Typography variant="Bold">{texts.PAGE_7_LINK_TEXT}</Typography>
          </Link>
        </div>
      </MainBox>
      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={texts.BUTTON_NEXT}
        secondaryButtonText={texts.BUTTON_BACK}
        disabled={!isButtonEnabled}
      />
    </>
  );
};

function IsValidRequest(request: IRiskLevel) {
  return (
    request.sustainability !== null &&
    request.sustainabilitySfdr !== null &&
    request.sustainabilityPai !== null &&
    request.sustainabilityEu !== null
  );
}
